
import Vue from 'vue';
import CommentOptions from '@/components/comment/CommentOptions.vue';
import CommentInput from '@/components/comment/CommentInput.vue';
import DeleteCommentModal from '@/components/modals/DeleteCommentModal.vue';
import { Avatar } from '@descomplica/vue-components';
import { DiscussionModel } from '@/models/forumAPI/DiscussionModel';
import { timeSinceCreation } from '@/helpers/date';
import EditorPreview from '../EditorPreview.vue';
import { UserModel } from '@descomplica/dex-models';
import { TranslateResult } from 'vue-i18n';
import FileContainer from '@/components/files/FileContainer.vue';
import i18n from '@/i18n';
import { FileModel } from '../../models/FileModel';

export default Vue.extend({
  components: {
    CommentOptions,
    Avatar,
    DeleteCommentModal,
    EditorPreview,
    FileContainer,
    CommentInput,
  },
  props: {
    user: {
      type: Object as Vue.PropType<UserModel>,
      required: true,
    },
    post: {
      type: Object as Vue.PropType<DiscussionModel>,
      required: true,
    },
    isSending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEditing: false as Boolean,
      deletePostModal: false as Boolean,
    };
  },
  computed: {
    postAttachments(): FileModel[] {
      const { attachments = [] } = this.post;
      return attachments;
    },
    modalTitle(): TranslateResult {
      return i18n.t('deletePostTitle');
    },
    modalSubtitle(): TranslateResult {
      return i18n.t('deletePostSubtitle');
    },
    isUserAdmin(): boolean {
      return this.user.isAdmin();
    },
    isMyPost(): boolean {
      if (!this.post || !this.post.author) return false;
      return this.post.userId === this.user.id;
    },
    author(): string {
      return this.post && this.post.userProfileName
        ? this.post.userProfileName
        : 'Aluno do Descomplica';
    },
    authorAvatar(): string {
      return this.post && this.post.userProfileAvatar ? this.post.userProfileAvatar : '';
    },
    postElapsedTime(): string {
      return timeSinceCreation(this.post.createdAt);
    },
  },
  methods: {
    deleteDiscussion() {
      this.$emit('deleteDiscussion');
    },
    toggleDeleteModal() {
      this.deletePostModal = !this.deletePostModal;
    },
    toggleIsEditing() {
      this.isEditing = !this.isEditing;
    },
    onPostEdit(text: string) {
      if (text) {
        this.$emit('onPostEdit', text);
      }
    },
  },
});
